// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jWd1wVNeAJDbP28JykRl{display:flex;flex-direction:column;gap:15px}.GSY6LPtQJmU4qDBmKF3R{display:grid;gap:4px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/BillingPlan/ui/CardFormFields/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAGF,sBACE,YAAA,CACA,OAAA","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.section {\n  display: grid;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `jWd1wVNeAJDbP28JykRl`,
	"section": `GSY6LPtQJmU4qDBmKF3R`
};
export default ___CSS_LOADER_EXPORT___;
